import { useEffect } from "react";
import { LocationService } from "../services";
import { initGoogleTagManager, setAnalyticsLocation } from "../utils";

/**
 * Loads the tenant's Google Tag Manager container for a public booking
 * page, looked up by location code. Tracking stays off when the tenant
 * has no container configured or the lookup fails.
 */
export const useBookingTracking = (locationCode?: string | null) => {
  useEffect(() => {
    if (!locationCode) return;

    setAnalyticsLocation(locationCode);
    new LocationService()
      .getTrackingAsync(locationCode)
      .then((tracking) => initGoogleTagManager(tracking?.googleTagManagerId))
      .catch(() => initGoogleTagManager(null));
  }, [locationCode]);
};

export default useBookingTracking;
